<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">年月</p>
        <el-date-picker
            class="inputDiv"
            v-model="yearValue"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择年月" clearable>
        </el-date-picker>
      </div>
      <el-button class="searchBtn btn1" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn btn4" type="warning" @click="printFun()">打 印</el-button>
<!--      //-->
      <el-button class="searchBtn btn2" type="warning" @click="uploadFunSum">导 入</el-button>
      <el-button class="searchBtn btn3" type="warning" @click="exportFunSum">导 出</el-button>
    </div>
<!--    累计数据列表-->
    <div class="sumTable">
      <el-table
          v-loading="loading"
          :data="tableDataSum"
          :default-sort = "{prop: 'id', order: 'descending'}"
          style="width: 100%"
          :highlight-current-row="false"
          :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
        <template v-for="(item, index) in tableSumColumns">
          <el-table-column
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width">
          </el-table-column>
        </template>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope" class="tableButton">
            <el-button class="tableBtn" @click="viewOrHandleSum(scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="btnDiv">
      <el-button class="searchBtn btn2" type="warning" @click="uploadFun">导 入</el-button>
      <el-button class="searchBtn btn3" type="warning" @click="exportFun">导 出</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
          class="paginationBody">
      </el-pagination>
    </div>
    <!--    总列表 新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="dialogFormVisibleSum"
          :before-close="closeAddSum"
          center
      >
        <el-form ref="addFormSum" :model="addFormSum" class="formDiv">
          <el-form-item label="年月" label-width="1.8rem" prop="statisticsMonth" class="formItem">
            <el-input v-model="addFormSum.statisticsMonth" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="当月开票数(万元)" label-width="1.8rem" prop="curMonthRental" class="formItem">
            <el-input v-model="addFormSum.curMonthInvoice" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="累计开票数(万元)" label-width="1.8rem" prop="correspondingRental" class="formItem">
            <el-input v-model="addFormSum.accumulatedInvoice"></el-input>
          </el-form-item>
          <el-form-item label="累计应收账(万元)" label-width="1.8rem" prop="curMonthIncome" class="formItem">
            <el-input v-model="addFormSum.accumulatedReceivables"></el-input>
          </el-form-item>
          <el-form-item label="累计未开票(万元)" label-width="1.8rem" prop="correspondingIncome" class="formItem">
            <el-input v-model="addFormSum.accumulatedNoInvoice"></el-input>
          </el-form-item>
          <el-form-item label="累计收缴率" label-width="1.8rem" prop="customerQuantity" class="formItemRemark">
            <el-input v-model="addFormSum.accumulatedCollectionRate"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAddSum">取 消</el-button>
          <el-button type="primary" @click="addEventFormSum()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="dialogFormVisible"
          :before-close="closeAdd"
          center
      >
        <el-form ref="addForm" :model="addForm" class="formDiv">
          <el-form-item label="年月" label-width="1.8rem" prop="statisticsMonth" class="formItem">
            <el-input v-model="addForm.statisticsMonth" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="楼宇" label-width="1.8rem" prop="curMonthRental" class="formItem">
            <el-input v-model="addForm.buildingName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="租赁名称" label-width="1.8rem" prop="correspondingRental" class="formItem">
            <el-input v-model="addForm.tenantName"></el-input>
          </el-form-item>
          <el-form-item label="面积（㎡）" label-width="1.8rem" prop="curMonthIncome" class="formItem">
            <el-input v-model="addForm.rentalArea"></el-input>
          </el-form-item>
          <el-form-item label="租金单价" label-width="1.8rem" prop="correspondingIncome" class="formItem">
            <el-input v-model="addForm.daliyRental"></el-input>
          </el-form-item>
          <el-form-item label="年租金（元）" label-width="1.8rem" prop="customerQuantity" class="formItem">
            <el-input v-model="addForm.annualRental"></el-input>
          </el-form-item>
          <el-form-item label="保证金（元）" label-width="1.8rem" prop="rentRate" class="formItem">
            <el-input v-model="addForm.securityDeposit"></el-input>
          </el-form-item>
          <el-form-item label="合同到期日" label-width="1.8rem" prop="collectionRate" class="formItem">
            <el-input v-model="addForm.contractPeriod"></el-input>
          </el-form-item>
          <el-form-item label="本期开票日" label-width="1.8rem" prop="accumulatedReceivables" class="formItem">
            <el-date-picker
                class="inputDiv"
                v-model="addForm.invoiceDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择年月日" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="租金是否到位/提醒" label-width="1.8rem" prop="accumulatedNoInvoice" class="formItemRemark">
            <el-input v-model="addForm.rentRemindRemark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd">取 消</el-button>
          <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
<!--    累计情况 导入弹框-->
    <!--    导入弹框-->
    <div class="dialogUploadDiv">
      <el-dialog title="当月累计情况表" :visible.sync="uploadDialogVisibleSum" center>
        <el-upload
            class="upload-demo"
            ref="uploadFileSum"
            action=""
            :auto-upload="false"
            :http-request="httpRequestSum"
            :on-change="handleChangeSum"
            :on-remove="handleRemoveSum"
            :file-list="fileListSum"
            show-file-list
            accept=".xls, .xlsx"
        >
          <el-button style="width: 1.5rem;"><i class="el-icon-upload2"></i>上传文件</el-button>
        </el-upload>
        <div class="imgAndText">
          <p>限Excel文件(后缀名为.xls或.xlsx),不超过10000条且文件大小控制在2M内</p>
          <div class="uploadRule">
            <p class="titleS">导入说明</p>
            <p>1.导入的文件格式为Excel格式，后缀名为.xls或.xlsx;</p>
            <p>2.导入的文件应放在文件的第一个工作表中;</p>
            <p>3.请勿修改导出表格的标题（第一行）;</p>
            <p>4.请务必填写表格中必填信息;</p>
            <p>5.Excel文件中, "年月"竖列仅支持"2024/01"或"2024-01"两种格式</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="searchBtn"  type="primary" @click="importFunSum()">提交</el-button>
          <el-button class="searchBtn searchBtn2" @click="uploadDialogVisibleFunSum()">取消</el-button>
        </span>
      </el-dialog>
    </div>
<!--    月度楼宇租金 导入弹框-->
    <div class="dialogUploadDiv">
    <el-dialog title="导入出租房屋租金收缴统计汇总表" :visible.sync="uploadDialogVisible" center>
      <el-upload
          class="upload-demo"
          ref="uploadFile"
          action=""
          :auto-upload="false"
          :http-request="httpRequest"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :file-list="fileList"
          show-file-list
          accept=".xls, .xlsx"
      >
        <el-button style="width: 1.5rem;"><i class="el-icon-upload2"></i>上传文件</el-button>
      </el-upload>
      <div class="imgAndText">
        <p>限Excel文件(后缀名为.xls或.xlsx),不超过10000条且文件大小控制在2M内</p>
        <div class="uploadRule">
          <p class="titleS">导入说明</p>
          <p>1.导入的文件格式为Excel格式，后缀名为.xls或.xlsx;</p>
          <p>2.导入的文件应放在文件的第一个工作表中;</p>
          <p>3.请勿修改导出表格的标题（第一行）;</p>
          <p>4.请务必填写表格中必填信息;</p>
          <p>5.Excel文件中, "年月"竖列仅支持"2024/01"或"2024-01"两种格式</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button class="searchBtn"  type="primary" @click="importFun()">提交</el-button>
          <el-button class="searchBtn searchBtn2" @click="uploadDialogVisibleFun()">取消</el-button>
        </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { queryExcelMonthBuilding, updateExcelMonthBuilding,
  exportExcelMonthBuilding, importExcelMonthBuilding, importExcelMonthSummary,
  exportExcelMonthSummary, queryExcelMonthSummary, updateExcelMonthSummary } from '@/api/statistics'
import moment from 'moment'
// let now = new Date()
export default {
  name: 'houseRent',
  data () {
    return {
      loading: false,
      yearValue: moment().subtract(1, 'months').format('YYYY-MM'),
      // yearValue: (now.getFullYear() + '-' + (now.getMonth() > 10 ? now.getMonth() : '0' + now.getMonth())).toString(),
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      dialogFormVisibleSum: false,
      eventControl: '',
      pageList: [],
      assignPageList: [],
      uploadDialogVisible: false,
      uploadDialogVisibleSum: false,
      fileList: [],
      fileListSum: [],
      addFormSum: {
        statisticsMonth: '',
        curMonthInvoice: '',
        accumulatedInvoice: '',
        accumulatedReceivables: '',
        accumulatedNoInvoice: '',
        accumulatedCollectionRate: '',
        id: ''
      },
      addForm: {
        statisticsMonth: '',
        buildingName: '',
        tenantName: '',
        rentalArea: '',
        daliyRental: '',
        annualRental: '',
        securityDeposit: '',
        contractPeriod: '',
        invoiceDate: '',
        rentRemindRemark: '',
        id: '',
        buildingId: ''
      },
      rules: {
        curMonthRental: [{ required: true, message: '请填写', trigger: 'blur' }],
        correspondingRental: [{ required: true, message: '请填写', trigger: 'blur' }],
        curMonthIncome: [{ required: true, message: '请填写', trigger: 'blur' }],
        correspondingIncome: [{ required: true, message: '请填写', trigger: 'blur' }],
        customerQuantity: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentRate: [{ required: true, message: '请填写', trigger: 'blur' }],
        collectionRate: [{ required: true, message: '请填写', trigger: 'blur' }],
        deposit: [{ required: true, message: '请填写', trigger: 'blur' }],
        accumulatedReceivables: [{ required: true, message: '请填写', trigger: 'blur' }],
        accumulatedNoInvoice: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableDataSum: [
        {}
      ],
      tableSumColumns: [
        {
          prop: 'statisticsMonth',
          label: '年月'
        },
        {
          prop: 'curMonthInvoice',
          label: '当月开票数（万元）'
        },
        {
          prop: 'accumulatedInvoice',
          label: '累计开票数（万元）'
        },
        {
          prop: 'accumulatedReceivables',
          label: '累计应收账（万元）'
        },
        {
          prop: 'accumulatedNoInvoice',
          label: '累计未开票（万元）'
        },
        {
          prop: 'accumulatedCollectionRate',
          label: '累计收缴率'
        }
      ],
      tableData: [],
      tableColumns: [
        {
          prop: 'statisticsMonth',
          label: '年月',
          width: 100
        },
        {
          prop: 'buildingName',
          label: '楼宇'
        },
        {
          prop: 'tenantName',
          label: '租赁名称'
        },
        {
          prop: 'rentalArea',
          label: '面积（㎡）',
          width: 100
        },
        {
          prop: 'daliyRental',
          label: '租金单价（元）',
          width: 120
        },
        {
          prop: 'annualRental',
          label: '年租金（元）',
          width: 110
        },
        {
          prop: 'securityDeposit',
          label: '保证金（元）',
          width: 110
        },
        {
          prop: 'contractPeriod',
          label: '合同到期日',
          width: 110
        },
        {
          prop: 'invoiceDate',
          label: '本期开票日'
        },
        {
          prop: 'rentRemindRemark',
          label: '租金是否到位/提醒'
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.currentPage = 1
      this.queryList()
      this.queryListSum()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    // 查询累计信息
    async queryListSum () {
      let res = await queryExcelMonthSummary({
        statisticsMonth: this.yearValue
      })
      if (res.code === 0) {
        this.tableDataSum = res.result.records
      }
    },
    // 查询
    async queryList () {
      let res = await queryExcelMonthBuilding({
        statisticsMonth: this.yearValue,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    viewOrHandleSum (row) {
      this.dialogFormVisibleSum = true
      this.eventControl = '编辑表格'
      this.addFormSum = row
    },
    viewOrHandle (row) {
      this.dialogFormVisible = true
      this.eventControl = '编辑汇总表'
      this.addForm = row
    },
    closeAddSum () {
      this.dialogFormVisibleSum = false
      this.$refs['addFormSum'].resetFields()
      this.queryListSum()
    },
    closeAdd () {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.getData()
    },
    // 累计情况更新
    addEventFormSum () {
      this.$refs['addFormSum'].validate(async (valid) => {
        if (valid) {
          let res = await updateExcelMonthSummary({
            statisticsMonth: this.addFormSum.statisticsMonth,
            curMonthInvoice: this.addFormSum.curMonthInvoice,
            accumulatedInvoice: this.addFormSum.accumulatedInvoice,
            accumulatedReceivables: this.addFormSum.accumulatedReceivables,
            accumulatedNoInvoice: this.addFormSum.accumulatedNoInvoice,
            accumulatedCollectionRate: this.addFormSum.accumulatedCollectionRate,
            id: this.addFormSum.id
          })
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.dialogFormVisibleSum = false
            this.$refs['addFormSum'].resetFields()
            await this.queryListSum()
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    // 月度楼宇详情更新
    addEventForm () {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          let res = await updateExcelMonthBuilding({
            statisticsMonth: this.addForm.statisticsMonth,
            buildingName: this.addForm.buildingName,
            tenantName: this.addForm.tenantName,
            rentalArea: this.addForm.rentalArea,
            daliyRental: this.addForm.daliyRental,
            annualRental: this.addForm.annualRental,
            securityDeposit: this.addForm.securityDeposit,
            contractPeriod: this.addForm.contractPeriod,
            invoiceDate: this.addForm.invoiceDate,
            rentRemindRemark: this.addForm.rentRemindRemark,
            id: this.addForm.id,
            tableType: this.addForm.tableType,
            buildingId: this.addForm.buildingId
          })
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.getData()
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    // 累计情况导入导出操作
    uploadFunSum () {
      this.uploadDialogVisibleSum = true
    },
    // 累计情况 上传文件，提交审核
    importFunSum () {
      if (this.isFileSelectedSum) {
        this.$refs.uploadFileSum.submit()
      } else {
        this.$message.error('请选择文件！')
      }
    },
    uploadDialogVisibleFunSum () {
      this.fileListSum = []
      this.uploadDialogVisibleSum = false
    },
    // 累计情况 导入
    async httpRequestSum (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('multipartFile ', file)
      let res = await importExcelMonthSummary(fd)
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        await this.queryListSum()
        this.fileListSum = []
        this.isFileSelectedSum = false
        this.uploadDialogVisibleSum = false
      } else {
        this.$message.error(res.message)
      }
    },
    handleChangeSum (file, fileList) {
      // fileList = fileList.slice(-1)
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file && fileList.length) {
        this.isFileSelectedSum = true
      }
    },
    handleRemoveSum (file, fileList) {
      if (!fileList.length) {
        this.isFileSelectedSum = false
      }
    },
    // 累计情况 导出
    async exportFunSum () {
      let res = await exportExcelMonthSummary({
        statisticsMonth: this.yearValue
      })
      const elink = document.createElement('a')
      elink.download = '出租房屋月度累计情况表.xls'
      elink.style.display = 'none'
      const blob = new Blob([res])
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },

    // 月度楼宇租金明细 导入导出操作
    // 导出
    async exportFun () {
      let res = await exportExcelMonthBuilding({
        statisticsMonth: this.yearValue
      })
      const elink = document.createElement('a')
      elink.download = '出租房屋月度租金收缴统计汇总表.xls'
      elink.style.display = 'none'
      const blob = new Blob([res])
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },
    uploadFun () {
      this.uploadDialogVisible = true
    },
    // 导入
    async httpRequest (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('multipartFile ', file)
      let res = await importExcelMonthBuilding(fd)
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        await this.getData()
        this.fileList = []
        this.isFileSelected = false
        this.uploadDialogVisible = false
      } else {
        this.$message.error(res.message)
      }
    },
    handleChange (file, fileList) {
      // fileList = fileList.slice(-1)
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file && fileList.length) {
        this.isFileSelected = true
      }
    },
    handleRemove  (file, fileList) {
      if (!fileList.length) {
        this.isFileSelected = false
      }
    },
    // 上传文件，提交审核
    importFun () {
      if (this.isFileSelected) {
        this.$refs.uploadFile.submit()
      } else {
        this.$message.error('请选择文件！')
      }
    },
    uploadDialogVisibleFun () {
      this.fileList = []
      this.uploadDialogVisible = false
    },
    // 打印时跳转页面
    printFun () {
      this.$router.push({
        path: '/report/printHouseRent',
        query: {
          yearValue: this.yearValue
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  .searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;

    .stateDiv {
      margin-top: 0.14rem;
      float: left;
    }

    .searchText {
      margin-top: 0.05rem;
      margin-right: 0.13rem;
      font-size: 0.2rem;
      color: #111111;
      float: left;
    }

    .inputDiv {
      width: 2.2rem;
      float: left;
    }

    .searchBtn {
      /*width: .7rem;*/
      /*height: 0.36rem;*/
      /*border-radius: 0.06rem;*/
      /*font-size: 0.18rem;*/
      margin-top: 0.14rem;
      /*padding-top: 0.1rem;*/
    }
    .btn1{
      margin-left: .5rem;
    }
    .btn2{
      margin-left: 6rem;
    }
    .btn3{
      margin-left: .5rem;
    }
    .btn4{
      margin-left: .5rem;
    }
  }
  .btnDiv{
    margin-top: .2rem;
    .btn2{
      margin-left: 11.4rem;
    }
    .btn3{
      margin-left: .5rem;
    }
  }
  .sumTable{
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;
  }
  .table{
    margin-top: .2rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;
    .searchList{
    }
    .paginationBody{
      margin-top: .1rem;
    }
  }
  .formDiv{
    .formItem{
      display: inline-block;
      width: 3.9rem;
      float: left;
      margin-left: .3rem;
      /deep/ .el-input__inner{
        width: 2.4rem;
      }
    }
    .formItemRemark{
      display: inline-block;
      width: 3.9rem;
      margin-left: .3rem;
      /deep/ .el-input__inner{
        width: 2.4rem;
      }
    }
  }
  .dialogDiv{
    /deep/ .el-dialog{
      width: 50%!important;
    }
  }
  .dialogUploadDiv{
    .imgAndText{
      p{
        margin-top: .2rem;
      }
      .titleS{
        font-size: .16rem;
        color: #1989fa;
      }
      .downloadTemp{
        width: 1.5rem;
        padding-left: .2rem;
        color: #1989fa;
        cursor: pointer;
        text-decoration:underline;
      }
    }
    /deep/ .el-dialog{
      width: 28%!important;
    }
  }
</style>
